var _style, _metadata, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTb6(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2_00000092427599890365712390000017678192519681329833_",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: 44,
    height: 44,
    viewBox: "0 0 42 42",
    style: {
      enableBackground: "new 0 0 42 42"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#231F20;}\r\n\t.st1{fill:#F9F4C7;stroke:#231F20;stroke-width:2;stroke-miterlimit:10;}\r\n")), _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, /*#__PURE__*/React.createElement("sfw", {
    xmlns: "&ns_sfw;"
  }, /*#__PURE__*/React.createElement("slices", null), /*#__PURE__*/React.createElement("sliceSourceBounds", {
    bottomLeftOrigin: "true",
    height: 42,
    width: 42,
    x: 0,
    y: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17.1,19.9c0.7-0.8,1.5-1.5,2.3-1.9s1.8-0.6,2.8-0.6s1.9,0.2,2.7,0.5s1.6,0.9,2.2,1.6s1.1,1.5,1.5,2.4 s0.5,1.9,0.5,2.9c0,1.5-0.3,2.8-1,4s-1.6,2.1-2.8,2.8s-2.6,1-4.1,1c-1.8,0-3.3-0.4-4.5-1.3s-2.2-2.1-2.9-3.8s-1-3.7-1-6.1 c0-2,0.2-3.7,0.6-5.3s1-2.8,1.8-3.9s1.7-1.8,2.8-2.3s2.3-0.8,3.7-0.8s2.5,0.3,3.5,0.8s1.8,1.2,2.3,1.9s0.8,1.5,0.8,2.2 c0,0.4-0.2,0.8-0.5,1.2s-0.7,0.5-1.2,0.5c-0.4,0-0.8-0.1-1.2-0.4s-0.6-0.7-0.8-1.1c-0.2-0.6-0.6-1.1-1.1-1.5s-1.1-0.6-1.8-0.6 c-0.5,0-1.1,0.2-1.6,0.5s-1,0.8-1.4,1.3C17.7,15.1,17.3,17.1,17.1,19.9L17.1,19.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.4,29.6c1,0,1.9-0.4,2.6-1.3s1-2,1-3.4c0-1-0.2-1.8-0.5-2.5s-0.8-1.2-1.3-1.6s-1.2-0.5-1.9-0.5 s-1.3,0.2-1.9,0.5s-1.1,0.8-1.4,1.5s-0.5,1.4-0.5,2.3c0,1.4,0.4,2.6,1.1,3.5S20.3,29.6,21.4,29.6L21.4,29.6z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 21,
    cy: 21,
    r: 20
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17.1,19.9c0.7-0.8,1.5-1.5,2.3-1.9s1.8-0.6,2.8-0.6s1.9,0.2,2.7,0.5s1.6,0.9,2.2,1.6s1.1,1.5,1.5,2.4 s0.5,1.9,0.5,2.9c0,1.5-0.3,2.8-1,4s-1.6,2.1-2.8,2.8s-2.6,1-4.1,1c-1.8,0-3.3-0.4-4.5-1.3s-2.2-2.1-2.9-3.8s-1-3.7-1-6.1 c0-2,0.2-3.7,0.6-5.3s1-2.8,1.8-3.9s1.7-1.8,2.8-2.3s2.3-0.8,3.7-0.8s2.5,0.3,3.5,0.8s1.8,1.2,2.3,1.9s0.8,1.5,0.8,2.2 c0,0.4-0.2,0.8-0.5,1.2s-0.7,0.5-1.2,0.5c-0.4,0-0.8-0.1-1.2-0.4s-0.6-0.7-0.8-1.1c-0.2-0.6-0.6-1.1-1.1-1.5s-1.1-0.6-1.8-0.6 c-0.5,0-1.1,0.2-1.6,0.5s-1,0.8-1.4,1.3C17.7,15.1,17.3,17.1,17.1,19.9L17.1,19.9z M21.4,29.6c1,0,1.9-0.4,2.6-1.3s1-2,1-3.4 c0-1-0.2-1.8-0.5-2.5s-0.8-1.2-1.3-1.6s-1.2-0.5-1.9-0.5s-1.3,0.2-1.9,0.5s-1.1,0.8-1.4,1.5s-0.5,1.4-0.5,2.3 c0,1.4,0.4,2.6,1.1,3.5S20.3,29.6,21.4,29.6L21.4,29.6z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTb6);
export default __webpack_public_path__ + "static/media/Tb6.39b1495001286c5927c8117fea05a738.svg";
export { ForwardRef as ReactComponent };